import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import referenceRequests from 'api/referenceRequests';
import { AxiosError } from 'axios';
import { Reference } from 'types';

export interface ReferenceRequestPayload {
  candidate_id: number;
  is_reminder: boolean;
  message: string;
  recipients: Reference[];
  reference_id: number;
  reference_template_id: number;
  role_title: string;
  subject: string;
}

export interface CreateRequestMutationVariables {
  payload: ReferenceRequestPayload;
}

export const requestReference = (candidateId: number, payload: ReferenceRequestPayload) =>
  referenceRequests.postRequest(candidateId, payload).then((res) => res);

export function useCreateReferenceRequest(
  candidateId: number,
  options?: Omit<
    UseMutationOptions<
      CreateRequestMutationVariables,
      AxiosError,
      ReferenceRequestPayload,
      unknown
    >,
    'mutationFn'
  >
): UseMutationResult<CreateRequestMutationVariables, AxiosError, ReferenceRequestPayload, unknown> {
  return useMutation({
    mutationFn: (payload) => requestReference(candidateId, payload),
    ...options,
  });
}
